<template>
  <BaseModal
    v-model="open"
    title="Agregar cancha"
    ok-label="Guardar"
    :loading="saving"
    layout="auto"
    :drawer-width="300"
    @confirm="onConfirm"
    @cancel="onCancel"
  >
    <form @submit.prevent="onConfirm">
      <div class="mb-3">
        <label class="form-label">Descripción</label>
        <input
          v-model.trim="form.descripcion"
          ref="descripcion"
          type="text"
          class="form-control"
          placeholder="Ej.: Cancha 1"
          required
        />
      </div>
      <p class="text-muted small mb-0">
        Deporte: <strong>{{ sport?.descripcion }}</strong>
      </p>
    </form>
  </BaseModal>

  <MostrarMensaje
    v-model:modelValue="validacionFormulario"
    status="error"
    message="Es obligatorio ingresar una descripción de la cancha"
    slug="error-guardado"
    :duration="5000"
    :closable="true"
  />
</template>

<script setup>
import { reactive, ref, watch, nextTick, onMounted } from "vue";
import BaseModal from "@/components/BaseModal.vue";
import MostrarMensaje from "./MostrarMensaje.vue";

const props = defineProps({
  modelValue: { type: Boolean, required: true },
  sport: { type: Object, required: true },
  cancha: { type: Object, default: () => ({}) },
});
const emit = defineEmits(["update:modelValue", "saved", "cancel"]);

const open = ref(props.modelValue);
watch(
  () => props.modelValue,
  async (v) => {
    open.value = v;
    if (v) {
      await nextTick();
      try {
        descripcionRef.value?.focus?.();
      } catch {}
    }
  }
);
watch(open, (v) => emit("update:modelValue", v));

const saving = ref(false);
const validacionFormulario = ref(false);

const form = reactive({ descripcion: "" });
const descripcionRef = ref(null);

async function onConfirm() {
  if (!form.descripcion) {
    validacionFormulario.value = true;
    return;
  }
  saving.value = true;
  try {
    const payload = {
      idDeporte: props.sport.id,
      descripcion: form.descripcion,
      idCancha: props?.cancha.id_cancha ?? null,
    };
    emit("saved", payload);
    emit("update:modelValue", false);
    form.descripcion = "";
  } catch (e) {
    console.error(e);
  } finally {
    saving.value = false;
  }
}
function onCancel() {
  form.descripcion = "";
  emit("cancel");
  emit("update:modelValue", false);
}

onMounted(() => {
  if (props.cancha !== undefined){
    form.descripcion = props.cancha.descripcion
    //props.sport.idCancha.value = props.cancha.id_cancha
  }
});
</script>
